"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forwardRef = exports.applyRef = exports.renderChildrenWithProps = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function renderChildrenWithProps(children, props) {
    if (typeof children === 'function') {
        return children(props);
    }
    return children || null;
}
exports.renderChildrenWithProps = renderChildrenWithProps;
/**
 * Use this HOC on the raw component, before registering in BlueBase
 * @param Component
 */
function applyRef(Component) {
    const ComponentWithApplyRef = (_a) => {
        var { bluebaseRef } = _a, rest = tslib_1.__rest(_a, ["bluebaseRef"]);
        return (react_1.default.createElement(Component, Object.assign({ ref: bluebaseRef }, rest)));
    };
    ComponentWithApplyRef.displayName = 'ComponentWithApplyRef';
    return ComponentWithApplyRef;
}
exports.applyRef = applyRef;
/**
 * Use this HOC on the component resolved from BlueBase or "getComponent" method
 * @param Component
 */
function forwardRef(Component) {
    const ForwardRefComponent = Component;
    // eslint-disable-next-line react/display-name
    return react_1.default.forwardRef((props, ref) => {
        return react_1.default.createElement(ForwardRefComponent, Object.assign({}, props, { bluebaseRef: ref }));
    });
}
exports.forwardRef = forwardRef;
